module.exports = __webpack_public_path__ + "static/img/8.ccfc59f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/8.jpg
// module id = of7W
// module chunks = 3